module.exports = __webpack_public_path__ + "static/media/opencv.b18a26d4.svg";